import { ZervantSubscriptionQuota } from '../types/zervantSubscriptionQuota'

const UNLIMITED_QUOTA = -1
export const getIsPremiumInvoicesQuotaReached = (quota?: ZervantSubscriptionQuota) => {
  if (!quota || quota.total === UNLIMITED_QUOTA) {
    return false
  }

  return quota.used >= quota.total
}
